export default __webpack_public_path__ + "assets/b4cb745ac96a1821f7140447c4b86d67.jpeg";